import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  z-index: -1;
  opacity: 0;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  transition: 0.3s ease-in-out all;

  &.active {
    z-index: 1001;
    pointer-events: auto;
    opacity: 1;
  }

  ${mediaMaxWidth.tablet} {
    align-items: unset;
  }
`;

export const ModalWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  width: 400px;
  height: 350px;
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  ${mediaMaxWidth.tablet} {
    top: 130px;
    margin-left: 0;
  }

  ${mediaMaxWidth.phone} {
    top: 10px;
    width: calc(100vw - 20px);
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #673490;
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: space-around;
  height: calc(100% - 40px);
  align-items: center;
`;

export const Paragraph = styled.p`
  margin: 0;
  text-align: center;
  line-height: 2.8em;
  font-size: 1em;
`;

export const ButtonsWrapper = styled.div``;

export const Button = styled.button`
  margin: 0 20px;
  justify-content: center;
  font-weight: bold;
  color: #fff;
  background-color: #f2008c;
  border: 1px solid #f2008c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  padding: 10px 12px;
  font-family: Raleway;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 90px;
  transition: 0.1s ease-in-out;
  outline: 2px solid transparent;

  &:hover {
    cursor: pointer;
    color: #fff;
    background-color: #bc006d;
    border: 1px solid #f2008c;
  }

  &:active,
  &:visited {
    cursor: pointer;
    color: #fff;
    background: #673490;
    border: 1px solid #673490;
    outline-color: #673490;
  }

  &:focus {
    background-color: #673490;
    border: 1px solid #673490;
    outline: none;
  }

  ${mediaMaxWidth.phone} {
    margin: 0 10px;
  }
`;
